module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_17.9f241a0e.png";